export default __webpack_public_path__ + "static/media/Coat_of_arms_of_Nigeria.40214f23.png";